import { FAMILY_TREE_RECEIVED, FAMILY_TREE_UNLOADED } from './types'

export default function familytree(state = {}, action = {}){
  switch (action.type) {
    case FAMILY_TREE_RECEIVED:
      return action.data
    case FAMILY_TREE_UNLOADED:
      return {}
    default:
      return state;
  }
}
